import { render, staticRenderFns } from "./FormPh.vue?vue&type=template&id=0176a670&scoped=true"
import script from "./FormPh.vue?vue&type=script&lang=js"
export * from "./FormPh.vue?vue&type=script&lang=js"
import style0 from "./FormPh.vue?vue&type=style&index=0&id=0176a670&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0176a670",
  null
  
)

export default component.exports